<template>
  <div class="export-setting h100">
    <div class="w100 h100 flex">
      <AnchorNav
        :getContainer="() => container"
        :navs="navs"
        prefix="NcExportSetting"
      />
      <div class="wrap h100 y-auto" ref="wrap">
        <span class="head-title" id="filename-setting">{{
          $t('cuttingDock.NCExportSettings.tab1')
        }}</span>
        <div class="main-setting">
          <div class="auto-sort" v-if="showConfig">
            <span id="span_otmfi2mwlb" class="mr8">{{
              $t(
                'cuttingDock.NCExportSettings.fileNameSettings.twoStationAutoSort'
              )
            }}</span>
            <a-switch
              v-model="formData.fileNameSetting.doubleStationSortName"
              id="engraving_setting_exportSetting_doubleStationSortName_checkbox"
              size="small"
            ></a-switch>
          </div>
          <div
            class="custom-head"
            v-show="
              (formData.fileNameSetting.doubleStationSortName ||
                isShowSecondaryCatalog) &&
              showConfig
            "
          >
            <span id="span_kb02kx53e5" class="mr8">{{
              $t('cuttingDock.NCExportSettings.machineOrder')
            }}</span>
            <a-checkbox
              v-model="formData.fileNameSetting.is_generate_process_sort_number"
              id="engraving_setting_exportSetting_isGenerateProcessSortNumber_checkbox"
              :disabled="!formData.fileNameSetting.doubleStationSortName"
            ></a-checkbox>
          </div>
          <div class="custom-head">
            <div class="plank-num-length">
              <span id="span_mv6rkyavez">{{
                $t('cuttingDock.NCExportSettings.fileNameSettings.reparation')
              }}</span>
              <a-input
                v-model="formData.fileNameSetting.stockNumLength"
                @input="inputCheck"
                @change="autoFileName"
                @dragover="handleDragOver"
                id="engraving_setting_exportSetting_stockNumLength_input"
              ></a-input>
              <span id="span_8d3hqol3yx">{{
                $t('cuttingDock.NCExportSettings.fileNameSettings.figure')
              }}</span>
            </div>
          </div>
          <div class="custom-head">
            <div class="custom-label-head">
              <span id="span_vpzrby38sw"
                >{{
                  $t(
                    'cuttingDock.NCExportSettings.fileNameSettings.labelerBegin'
                  )
                }}:</span
              >
              <div class="has-error-info">
                <a-input
                  v-model="formData.fileNameSetting.labelMachineName"
                  @input="wordLimit('labelMachineName', 1)"
                  :maxLength="16"
                  id="engraving_setting_exportSetting_labelmachineName_input"
                  @dragover="handleDragOver"
                ></a-input>
                <span class="error-info" ref="error1">{{ errorStr }}</span>
              </div>
            </div>
            <div class="custom-cure-head">
              <span id="span_75fdiw1xez"
                >{{
                  $t(
                    'cuttingDock.NCExportSettings.fileNameSettings.machineCenter'
                  )
                }}:</span
              >
              <div class="has-error-info">
                <a-input
                  v-model="formData.fileNameSetting.machineCenterName"
                  @input="wordLimit('machineCenterName', 2)"
                  :maxLength="16"
                  id="engraving_setting_exportSetting_nachineCenterName_input"
                  @dragover="handleDragOver"
                ></a-input>
                <span class="error-info" ref="error2">{{ errorStr }}</span>
              </div>
            </div>
          </div>
          <div
            class="custom-head"
            id="engraving_setting_exportSetting_head_side"
          >
            <div class="custom-label-head">
              <span id="span_3coi5wctn2">{{
                $t('cuttingDock.NCExportSettings.fileNameSettings.front')
              }}</span>
              <div class="has-error-info">
                <a-input
                  v-model="formData.fileNameSetting.front_info"
                  @input="wordLimit('front_info', 3)"
                  :maxLength="16"
                  id="engraving_setting_exportSetting_front_input"
                  :class="[isNullFileSide ? 'custom-head-err-boder ' : '']"
                  @dragover="handleDragOver"
                ></a-input>
                <span class="error-info" ref="error3">{{ errorStr }}</span>
              </div>
            </div>
            <div class="custom-cure-head">
              <span id="span_rw6c3qm362">{{
                $t('cuttingDock.NCExportSettings.fileNameSettings.back')
              }}</span>
              <div class="has-error-info">
                <a-input
                  v-model="formData.fileNameSetting.back_info"
                  @input="wordLimit('back_info', 4)"
                  :maxLength="16"
                  id="engraving_setting_exportSetting_back_input"
                  :class="[isNullFileSide ? 'custom-head-err-boder ' : '']"
                  @dragover="handleDragOver"
                ></a-input>
                <span class="error-info" ref="error4">{{ errorStr }}</span>
              </div>
            </div>
            <div class="ml10">
              <span
                id="span_bhyo0uifxa"
                :class="[
                  'error-info',
                  isNullFileSide ? 'error-info-in' : '',
                  'err-text-tip',
                ]"
                >{{
                  $t('cuttingDock.NCExportSettings.fileNameSettings.emptyTip')
                }}</span
              >
            </div>
          </div>
          <!-- 四边修边输入框 -->
          <div class="custom-head pb0 flex-wrap--wrap" style="width: 810px">
            <div
              class="custom-label-head"
              v-for="(item, index) in edgeArr"
              :key="item.value"
              style="margin-bottom: 24px"
            >
              <span id="span_w9p1p5fopr"
                >{{
                  $t('basePlankManager.edgeDir', {
                    type: $t(`basePlankManager.${item.label}`),
                  })
                }}:</span
              >
              <div class="has-error-info">
                <a-input
                  v-model="formData.fileNameSetting.trim_direction_list[index]"
                  @input="wordLimit('trim_direction_list', 5 + index, index)"
                  :maxLength="16"
                  :id="`engraving_setting_exportSetting_${item.value}_edge_input`"
                  :class="[isNullFileSide ? 'custom-head-err-boder ' : '']"
                  @dragover="handleDragOver"
                ></a-input>
                <span
                  class="error-info"
                  :class="{ 'error-info-in': item.errorInfoIn }"
                  :ref="`error${5 + index}`"
                  >{{ errorStr }}</span
                >
              </div>
            </div>
          </div>
          <div class="custom-head plank-mark">
            <span class="pt6">{{ $translateLang('大板长度标识') }}：</span>
            <div>
              <div
                class="length-identifier-item"
                v-for="(item, index) in formData.fileNameSetting
                  .big_plank_length_marking_range"
                :key="index"
              >
                <span class="mr5">{{ $translateLang('长度') }}</span>
                <a-input
                  suffix="mm"
                  v-model="item.min_length"
                  @input="
                    verifyInput({
                      value: item.min_length,
                      formData: item,
                      keys: ['min_length'],
                      rule: '5-2',
                      isThickFlag: true,
                    })
                  "
                  @dragover="handleDragOver"
                ></a-input>
                <span class="mh5">{{ $translateLang('到') }}</span>
                <a-input
                  suffix="mm"
                  v-model="item.max_length"
                  @input="
                    verifyInput({
                      value: item.max_length,
                      formData: item,
                      keys: ['max_length'],
                      rule: '5-2',
                      isThickFlag: true,
                    })
                  "
                  @dragover="handleDragOver"
                ></a-input>
                <span class="ml10 mr5">{{ $translateLang('标识为') }}</span>
                <a-input
                  v-model="item.marking"
                  @input="handleInputMark(index)"
                  @dragover="handleDragOver"
                ></a-input>
                <span class="add-btn" @click="handleAddMarking">{{
                  $translateLang('添加')
                }}</span>
                <span class="delete-btn" @click="handleDeleteMarking(index)">{{
                  $translateLang('删除')
                }}</span>
              </div>
            </div>
          </div>

          <div class="custom-head flex flex-cross--center">
            <span id="span_l5ddtovf42"
              >{{ $translateLang('高光面翻面放板') }}：</span
            >
            <a-input
              style="width: 238px"
              id="engraving_setting_custom_high_gloss_reverse_input"
              v-model="formData.fileNameSetting.custom_high_gloss_reverse"
            ></a-input>
          </div>
          <div class="tag-lake">
            <div class="tag-box">
              <div class="custom-form-head">
                <span id="span_kec8xgsrde">{{
                  $t('cuttingDock.NCExportSettings.fileNameSettings.labelPool')
                }}</span>
                <span id="span_godu31p739" class="ml10">{{
                  $t('cuttingDock.NCExportSettings.fileNameSettings.dragTip')
                }}</span>
              </div>
              <div
                class="custom-form-main"
                v-for="(item, index) in tagList"
                :key="index"
              >
                <div class="tag-item">
                  <span>{{ $t(item.title) }}：</span>
                  <div class="tags">
                    <span
                      v-for="(items, indexs) in item.arr"
                      :key="indexs + '1'"
                      :class="`tag-item${indexs}`"
                      @dragstart="startDrag($event, items)"
                      @click="copyTag(indexs)"
                      data-clipboard-action="copy"
                      :data-clipboard-text="'{' + items.label_name_show + '}'"
                      draggable="true"
                      :id="`engraving_setting_exportSetting_tagList_${index}_${indexs}`"
                      >{{ items.label_name_show }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="custom-file-name">
              <div class="file-name-format">
                <span id="span_gg47u36myh">{{
                  $t(
                    'cuttingDock.NCExportSettings.fileNameSettings.customizeName'
                  )
                }}</span>
                <div
                  @drop="dropOver($event)"
                  @dragover="handleDragOver($event)"
                  :ref="`format_table_input`"
                  @change="autoFileName"
                  class="file-format-box"
                >
                  <div v-for="(item, index) in nameArr" :key="index">
                    <span class="tag">
                      {{ item }}
                      <i
                        class="el-icon-close"
                        @click="removeItem(index)"
                        :id="`engraving_setting_exportSetting_tag_${index}_remove_btn`"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
              <div class="file-has-delimiter">
                <span id="span_zxkndvtg4s"
                  >{{
                    $t('cuttingDock.labelingSettings.imgSetting.delimiter')
                  }}:</span
                >
                <a-input
                  v-model="formData.fileNameSetting.hasDelimiter"
                  @input="modifyDelimiter"
                  :maxLength="1"
                  id="engraving_setting_exportSetting_hasDelimiter_input"
                ></a-input>
              </div>
              <div class="file-name-example">
                <span id="span_qgrat2xl40">{{
                  $t('cuttingDock.NCExportSettings.fileNameSettings.example')
                }}</span>
                <span>{{ exampleFileName }}</span>
              </div>
            </div>
          </div>
          <div class="merge-box" id="merge-box">
            <div class="merge-box-title">
              <span id="span_i2f470mcyp">{{
                $t('cuttingDock.NCExportSettings.fileMerge.engravingMerge')
              }}</span>
              <a-switch
                default-checked
                v-model="isMergeFile"
                @change="fileMergeChange"
                id="engraving_setting_exportSetting_isMergeFile_switch"
              ></a-switch>
            </div>
            <div
              class="radio-check-box"
              v-show="isShowSecondaryCatalog || isMergeFile"
            >
              <a-radio-group
                v-model="mergeRadio"
                :disabled="!isMergeFile"
                @change="changeFileMerge"
              >
                <div class="radio-check-item">
                  <a-radio
                    value="doubleMerge"
                    :disabled="!isMergeFile"
                    id="engraving_setting_exportSetting_doubleMerge_radio"
                    ><span
                      id="engraving_setting_exportSetting_doubleMerge_radio_label"
                      >{{
                        $t('cuttingDock.NCExportSettings.fileMerge.zfMerge')
                      }}</span
                    ></a-radio
                  >
                  <a-checkbox-group
                    :disabled="mergeRadio != 'doubleMerge'"
                    v-model="frontBackStation"
                    @change="changeDoubleMerge"
                  >
                    <a-checkbox
                      :disabled="!isMergeFile"
                      value="bEnd1"
                      id="engraving_setting_exportSetting_doubleMerge_bEnd1_checkbox"
                      ><span
                        id="engraving_setting_exportSetting_doubleMerge_bEnd1_checkbox_label"
                        >{{
                          $t('cuttingDock.NCExportSettings.fileMerge.fEndCode')
                        }}</span
                      ></a-checkbox
                    >
                    <a-checkbox
                      :disabled="!isMergeFile"
                      value="fBegin1"
                      id="engraving_setting_exportSetting_doubleMerge_fBegin1_checkbox"
                      ><span
                        id="engraving_setting_exportSetting_doubleMerge_fBegin1_checkbox_label"
                        >{{
                          $t(
                            'cuttingDock.NCExportSettings.fileMerge.zBeginCode'
                          )
                        }}</span
                      ></a-checkbox
                    >
                    <a-checkbox
                      id="a_checkbox_cvs3c8my58"
                      :disabled="!isMergeFile"
                      value="displayfbInfo"
                      >{{
                        $t(
                          'cuttingDock.NCExportSettings.fileMerge.displayfbInfo'
                        )
                      }}</a-checkbox
                    >
                  </a-checkbox-group>
                </div>
                <div class="radio-check-item">
                  <a-radio
                    value="singleStation"
                    id="engraving_setting_exportSetting_singleStation_radio"
                    ><span
                      id="engraving_setting_exportSetting_singleStation_radio_label"
                      >{{
                        $t('cuttingDock.NCExportSettings.fileMerge.singleMerge')
                      }}</span
                    ></a-radio
                  >
                  <a-checkbox-group
                    :disabled="mergeRadio != 'singleStation' || !isMergeFile"
                    v-model="singleStation"
                    @change="changeSingleStation"
                  >
                    <a-checkbox
                      value="bBegin2"
                      id="engraving_setting_exportSetting_singleStation_bBegin2_checkbox"
                      ><span
                        id="engraving_setting_exportSetting_singleStation_bBegin2_checkbox_label"
                        >{{
                          $t(
                            'cuttingDock.NCExportSettings.fileMerge.fBeginCode'
                          )
                        }}</span
                      ></a-checkbox
                    >
                    <a-checkbox
                      value="bEnd2"
                      id="engraving_setting_exportSetting_singleStation_bEnd2_checkbox"
                      ><span
                        id="engraving_setting_exportSetting_singleStation_bEnd2_checkbox_label"
                        >{{
                          $t('cuttingDock.NCExportSettings.fileMerge.fEndCode')
                        }}</span
                      ></a-checkbox
                    >
                    <a-checkbox
                      value="fBegin2"
                      id="engraving_setting_exportSetting_singleStation_fBegin2_checkbox"
                      ><span
                        id="engraving_setting_exportSetting_singleStation_fBegin2_checkbox_label"
                        >{{
                          $t(
                            'cuttingDock.NCExportSettings.fileMerge.zBeginCode'
                          )
                        }}</span
                      ></a-checkbox
                    >
                    <a-checkbox
                      value="fEnd2"
                      id="engraving_setting_exportSetting_singleStation_fEnd2_checkbox"
                      ><span
                        id="engraving_setting_exportSetting_singleStation_fEnd2_checkbox_label"
                        >{{
                          $t('cuttingDock.NCExportSettings.fileMerge.zEndCode')
                        }}</span
                      ></a-checkbox
                    >
                  </a-checkbox-group>
                </div>
                <div class="radio-check-item" v-if="showConfig">
                  <a-radio
                    value="doubleStation"
                    id="engraving_setting_exportSetting_doubleStation_radio"
                    ><span
                      id="engraving_setting_exportSetting_doubleStation_radio_label"
                      >{{
                        $t('cuttingDock.NCExportSettings.fileMerge.doubleMerge')
                      }}</span
                    ></a-radio
                  >
                  <a-checkbox-group
                    :disabled="mergeRadio != 'doubleStation' || !isMergeFile"
                    v-model="doubleStation"
                    @change="changeDoubleStation"
                  >
                    <a-checkbox
                      value="bBegin3"
                      id="engraving_setting_exportSetting_doubleStation_bBegin3_checkbox"
                      ><span
                        id="engraving_setting_exportSetting_doubleStation_bBegin3_checkbox_label"
                        >{{
                          $t(
                            'cuttingDock.NCExportSettings.fileMerge.fBeginCode'
                          )
                        }}</span
                      ></a-checkbox
                    >
                    <a-checkbox
                      value="bEnd3"
                      id="engraving_setting_exportSetting_doubleStation_bEnd3_checkbox"
                      ><span
                        id="engraving_setting_exportSetting_doubleStation_bEnd3_checkbox_label"
                        >{{
                          $t('cuttingDock.NCExportSettings.fileMerge.fEndCode')
                        }}</span
                      ></a-checkbox
                    >
                    <a-checkbox
                      value="fBegin3"
                      id="engraving_setting_exportSetting_doubleStation_fBegin3_checkbox"
                      ><span
                        id="engraving_setting_exportSetting_doubleStation_fBegin3_checkbox_label"
                        >{{
                          $t(
                            'cuttingDock.NCExportSettings.fileMerge.zBeginCode'
                          )
                        }}</span
                      ></a-checkbox
                    >
                    <a-checkbox
                      value="fEnd3"
                      id="engraving_setting_exportSetting_doubleStation_fEnd3_checkbox"
                      ><span
                        id="engraving_setting_exportSetting_doubleStation_fEnd3_checkbox_label"
                        >{{
                          $t('cuttingDock.NCExportSettings.fileMerge.zEndCode')
                        }}</span
                      ></a-checkbox
                    >
                  </a-checkbox-group>
                </div>
              </a-radio-group>
            </div>
          </div>
          <div class="annotation" id="annotation">
            <span id="span_t8y02auyy5" class="head-title">{{
              $t('cuttingDock.NCExportSettings.tab3')
            }}</span>
            <div class="annotation-box">
              <div>
                <label for="test">
                  <span id="span_hnnc8vqg56">{{
                    $t(
                      'cuttingDock.NCExportSettings.marginalNotes.addPlankInfo'
                    )
                  }}</span>
                  <a-checkbox
                    id="test"
                    v-model="formData.fileAnnotation.beforePlankAddInfo"
                    class="engraving_setting_exportSetting_beforePlankAddInfo_checkbox"
                  ></a-checkbox>
                </label>
              </div>
              <div class="plank-info">
                <span id="span_6fep5f37i2">{{
                  $t('cuttingDock.NCExportSettings.marginalNotes.plankInfo')
                }}</span>
                <a-textarea
                  id="engraving_setting_exportSetting_plankInfo_textarea"
                  @blur="
                    blurSelect(
                      $event,
                      formData.fileAnnotation.beforePlankAddCustomizeInfo,
                      customTag.plank_info
                    )
                  "
                  v-model="
                    formData.fileAnnotation.beforePlankAddCustomizeInfo
                      .template_string
                  "
                  @change="
                    tagPoolTextareaChange(
                      formData.fileAnnotation.beforePlankAddCustomizeInfo,
                      customTag.plank_info
                    )
                  "
                  @drop="
                    dragTagOver(
                      $event,
                      formData.fileAnnotation.beforePlankAddCustomizeInfo,
                      customTag.plank_info
                    )
                  "
                />
              </div>
              <div v-if="showConfig">
                <span id="span_6aokmfa8d9">{{
                  $t(
                    'cuttingDock.NCExportSettings.marginalNotes.addStationCodeFirst'
                  )
                }}</span>
                <a-checkbox
                  v-model="formData.fileAnnotation.beforePlank"
                  id="engraving_setting_exportSetting_beforePlank_textarea"
                ></a-checkbox>
              </div>
              <div v-if="showConfig">
                <span id="span_3up0vs1lv1">{{
                  $t(
                    'cuttingDock.NCExportSettings.marginalNotes.addStationCodeSecond'
                  )
                }}</span>
                <a-checkbox
                  v-model="formData.fileAnnotation.beforeStartKnife"
                  id="engraving_setting_exportSetting_beforeStartKnife_checkbox"
                ></a-checkbox>
              </div>
            </div>
            <div class="tag-pool">
              <DataTagPool
                :tagList="customTag.plank_info"
                :dropData.sync="dropData"
                @selectChange="selectChange"
                @dragStart="handleDargStart"
              ></DataTagPool>
            </div>
          </div>
          <div class="format" id="format-type">
            <span id="span_7fiswexmzn" class="head-title">{{
              $t('cuttingDock.NCExportSettings.tab4')
            }}</span>
            <div class="format-box">
              <div class="format-check-box">
                <div>
                  <span id="span_6hlgvu8umk">{{
                    $t('cuttingDock.NCExportSettings.fileType.zAddtion')
                  }}</span>
                  <a-checkbox
                    v-model="formData.fileType.alwaysZ"
                    id="engraving_setting_exportSetting_alwaysZ_checkbox"
                  ></a-checkbox>
                </div>
                <div>
                  <span id="span_w7rsys1fl5">{{
                    $t('cuttingDock.NCExportSettings.fileType.addSemicolon')
                  }}</span>
                  <a-checkbox
                    class="mr10"
                    id="engraving_setting_exportSetting_semicolon_checkbox"
                    v-model="formData.fileType.semicolon"
                  ></a-checkbox>
                  <span id="span_qwlf6a7ega" class="color-a"
                    >（{{
                      $t('cuttingDock.NCExportSettings.fileType.semicolonTip')
                    }}）</span
                  >
                </div>
              </div>
              <div class="xinghui">
                <span id="span_anrmq5qm1a" class="mr10"
                  >{{
                    $t('cuttingDock.NCExportSettings.fileType.fileName')
                  }}:</span
                >
                <a-checkbox
                  class="mr10"
                  v-model="formData.fileType.exportUsingBanlu"
                  id="engraving_setting_exportSetting_exportUsingBanlu_checkbox"
                ></a-checkbox>
                <a-radio-group
                  v-model="formData.fileType.exportFormat"
                  @change="changeExportFormat"
                >
                  <a-radio
                    value="default"
                    :disabled="!formData.fileType.exportUsingBanlu"
                    id="engraving_setting_exportSetting_exportFormat_radio"
                    ><span
                      id="engraving_setting_exportSetting_exportFormat_radio_label"
                      >{{
                        $t('cuttingDock.NCExportSettings.fileType.defaultName')
                      }}</span
                    ></a-radio
                  >
                  <a-radio
                    value="xinghui"
                    :disabled="!formData.fileType.exportUsingBanlu"
                    id="engraving_setting_exportSetting_xinghui_radio"
                    ><span
                      id="engraving_setting_exportSetting_xinghui_radio_label"
                      >{{
                        $t(
                          'cuttingDock.NCExportSettings.fileType.dedicatedName'
                        )
                      }}</span
                    >

                    <span class="xinghui-zhushi">
                      (<a-checkbox
                        v-model="xinghuiE2_9"
                        @change="changeXinghuiAnnotation"
                        :disabled="
                          formData.fileType.exportFormat != 'xinghui' ||
                          !formData.fileType.exportUsingBanlu
                        "
                        id="engraving_setting_exportSetting_xinghui_zhushi_checkbox"
                        ><span
                          id="engraving_setting_exportSetting_xinghui_zhushi_checkbox_label"
                          >{{
                            $t('cuttingDock.NCExportSettings.fileType.xhNotes')
                          }}</span
                        ></a-checkbox
                      >)
                    </span>
                  </a-radio>
                </a-radio-group>
              </div>
              <div class="format-radio-box">
                <span
                  id="span_xczcq7e8x3"
                  style="line-height: 32px"
                  class="mr10"
                  >{{
                    $t('cuttingDock.NCExportSettings.fileType.format')
                  }}:</span
                >
                <el-input
                  class="mr10"
                  size="small"
                  v-model="formData.fileType.fileExtensionName"
                  style="width: 200px"
                  ref="fileNameType"
                  id="ncExportSetting_fileNameType_input"
                >
                </el-input>
                <span id="span_6h0fh75mxg" style="line-height: 32px"
                  >{{ $t('cuttingDock.NCExportSettings.fileType.example')
                  }}{{ formData.fileType.fileExtensionName }}</span
                >
                <div
                  id="div_ow2jua753s"
                  v-show="isContainsSpecialChars"
                  class="err-tip absolute"
                >
                  {{
                    $t('cuttingDock.NCExportSettings.fileType.fileNameErrTip')
                  }}
                  &lt; &gt; |
                </div>
              </div>
              <div>
                <span
                  id="span_2f278v8zff"
                  style="line-height: 32px"
                  class="mr10"
                  >{{
                    $t('cuttingDock.NCExportSettings.fileType.stillGenerate')
                  }}:</span
                >
                <a-checkbox
                  class="mr10"
                  v-model="formData.fileType.always_back_nc"
                  id="ncExportSetting_always_back_nc_checkbox"
                ></a-checkbox>
                <span id="span_15i9prac2g" class="color-a"
                  >（{{
                    $t('cuttingDock.NCExportSettings.fileType.generateTip')
                  }}）</span
                >
              </div>
            </div>
          </div>
          <div class="format" id="format-file">
            <span id="span_i47jfpnjml" class="head-title">{{
              $t('cuttingDock.NCExportSettings.tab5')
            }}</span>
            <div class="format-box">
              <goToMoreSettings
                :function-name="$t('cuttingDock.NCExportSettings.jumpSkipTip2')"
                :module-name="translateLang('main.head.fileManager')"
                router-path="/fileManage"
                :query-setting-id="$route.query.setting_id"
              >
              </goToMoreSettings>
            </div>
          </div>
          <div class="g-order" id="g-order">
            <div id="div_7vi58h2bn7" class="head-title">
              {{ $t('cuttingDock.NCExportSettings.tab6') }}
            </div>
            <div class="common-box">
              <span id="span_7ndf5tdcgx" class="small-title mr10">{{
                $t('cuttingDock.NCExportSettings.simplifyG')
              }}</span>
              <a-checkbox
                v-model="
                  formData.processingInstructionSetting.GCommandShorthand
                "
                id="engraving_setting_exportSetting_GCommandShorthand_radio"
              ></a-checkbox>
            </div>
            <div class="common-box">
              <span id="span_6ds7epiyut" class="small-title mr10">{{
                $t('cuttingDock.NCExportSettings.ZToW')
              }}</span>
              <!-- <a-checkbox
                v-model="formData.processingInstructionSetting.z_to_w_normal"
                >常规刀具</a-checkbox
              > -->
              <a-checkbox
                id="a_checkbox_5tjr7kefa7"
                v-model="
                  formData.processingInstructionSetting.z_to_w_gang_drill
                "
                >{{ $t('cuttingDock.NCExportSettings.knives') }}</a-checkbox
              >
            </div>
          </div>
          <div class="fileFormatSetting" id="fileFormatSetting">
            <div id="div_zrwfp5m7pd" class="head-title">
              {{ $t('cuttingDock.NCExportSettings.tab7') }}
            </div>
            <div class="file-format-setting-box">
              <div class="common-box">
                <span id="span_asig28pjti" class="small-title">{{
                  $t('cuttingDock.NCExportSettings.lineBreakSetting')
                }}</span>
                <a-radio-group v-model="formData.fileFormatSetting.platform">
                  <a-radio
                    value="windows"
                    id="engraving_setting_exportSetting_platform_windows_radio"
                    ><span
                      id="engraving_setting_exportSetting_platform_windows_radio_label"
                      >windows</span
                    ></a-radio
                  >
                  <a-radio
                    value="unix"
                    id="engraving_setting_exportSetting_platform_unix_radio"
                    ><span
                      id="engraving_setting_exportSetting_platform_unix_radio_label"
                      >unix</span
                    ></a-radio
                  >
                </a-radio-group>
              </div>
              <div class="common-box">
                <span id="span_hhytsu2qrk" class="small-title">{{
                  $t('cuttingDock.NCExportSettings.codeFormatSetting')
                }}</span>
                <a-radio-group
                  v-model="formData.fileFormatSetting.fileEncoding"
                >
                  <a-radio
                    value="utf-8"
                    id="engraving_setting_exportSetting_fileEncoding_utf8_radio"
                    ><span
                      id="engraving_setting_exportSetting_fileEncoding_utf8_radio_label"
                      >UTF-8</span
                    ></a-radio
                  >
                  <a-radio
                    value="utf8bom"
                    id="engraving_setting_exportSetting_fileEncoding_utf8bom_radio"
                    ><span
                      id="engraving_setting_exportSetting_fileEncoding_utf8bom_radio_label"
                      >{{ $t('cuttingDock.NCExportSettings.utf8bom') }}</span
                    ></a-radio
                  >
                  <a-radio
                    value="gbk"
                    id="engraving_setting_exportSetting_fileEncoding_gbk_radio"
                    ><span
                      id="engraving_setting_exportSetting_fileEncoding_gbk_radio_label"
                      >ansi</span
                    ></a-radio
                  >
                </a-radio-group>
              </div>
            </div>
          </div>
          <div class="plank-code" id="plank-code">
            <div id="div_i3o1eqckd2" class="head-title">
              {{ $t('cuttingDock.NCExportSettings.oneCodeSetting') }}
            </div>
            <div class="common-box">
              <div class="mb20">
                <span id="span_oxnd96rxbt" class="small-title mr10"
                  >{{ $t('cuttingDock.NCExportSettings.uniqueBarCode') }}
                </span>
                <a-checkbox
                  :disabled="formData.barCodeSetting.uniqueBarCodeForPack"
                  v-model="formData.barCodeSetting.uniqueBarCode"
                  id="engraving_setting_exportSetting_uniqueBarCode_checkbox"
                ></a-checkbox>
              </div>
              <div class="mb20">
                <span id="span_u626cnye1b" class="small-title mr10"
                  >{{ $t('cuttingDock.NCExportSettings.uniqueBarCodeForPack') }}
                </span>
                <a-checkbox
                  :disabled="formData.barCodeSetting.uniqueBarCode"
                  v-model="formData.barCodeSetting.uniqueBarCodeForPack"
                  id="engraving_setting_exportSetting_uniqueBarCodeForPack_checkbox"
                ></a-checkbox>
              </div>
              <span id="span_bvhv1ywknk" class="small-title mr10"
                >{{ $t('cuttingDock.NCExportSettings.simplifyOneCode') }}
              </span>
              <a-checkbox
                v-model="formData.barCodeSetting.genSimpleLabelBarcode"
                id="engraving_setting_exportSetting_genSimpleLabelBarcode_checkbox"
              ></a-checkbox>
            </div>
          </div>
          <div class="plank-code" id="plank-code">
            <div id="div_ocpdb6dyvk" class="head-title">
              {{ $t('cuttingDock.NCExportSettings.codeLocation') }}
            </div>
            <div class="common-box">
              <span id="span_sg72r5y5e7" class="small-title mr10"
                >{{ $t('cuttingDock.NCExportSettings.generateLocation') }}
              </span>
              <a-checkbox
                v-model="
                  formData.codePositionSetting.stationEndCodeBeforeEndCodeB
                "
                id="engraving_setting_exportSetting_stationEndCodeBeforeEndCodeB_checkbox"
              ></a-checkbox>
            </div>
          </div>
          <div class="plank-code" id="plank-code">
            <div id="div_9k4n055vnh" class="head-title">
              {{ $t('cuttingDock.NCExportSettings.emergencySetting') }}
            </div>
            <div class="common-box">
              <span id="span_phz22idntm" class="small-title mr10"
                >{{ $t('cuttingDock.NCExportSettings.show') }}
              </span>
              <a-checkbox
                v-model="isShowEmergencySetting"
                id="engraving_setting_exportSetting_isShowEmergencySetting_checkbox"
              ></a-checkbox>
              <span id="span_jftvqbxdg6" class="color-a"
                >（{{ $t('cuttingDock.NCExportSettings.emergencyTip') }}）</span
              >
            </div>
            <div v-if="isShowEmergencySetting" class="ml20 mb10">
              <div
                v-for="(emergencyItem, index) in formData.emergencySetting"
                :key="index"
                class="mb16 flex"
              >
                <span id="span_fgsmjjq4bw" class="mr16 bold"
                  >功能{{ index + 1 }}</span
                >
                <div>
                  <div>
                    <el-input
                      style="width: 320px"
                      v-model="emergencyItem.settingKey"
                      maxlength="20"
                      show-word-limit
                      :placeholder="
                        $t('cuttingDock.NCExportSettings.emergencyCode')
                      "
                      class="mb10"
                      id="engraving_setting_exportSetting_settingKey_input"
                    ></el-input>
                  </div>
                  <div>
                    <el-input
                      :placeholder="`${$t(
                        'cuttingDock.NCExportSettings.params'
                      )}1`"
                      style="width: 100px"
                      v-model="emergencyItem.param1"
                      maxlength="20"
                      show-word-limit
                      class="mr10"
                      id="engraving_setting_exportSetting_param1_input"
                    ></el-input>
                    <el-input
                      :placeholder="`${$t(
                        'cuttingDock.NCExportSettings.params'
                      )}2`"
                      style="width: 100px"
                      v-model="emergencyItem.param2"
                      maxlength="20"
                      show-word-limit
                      class="mr10"
                      id="engraving_setting_exportSetting_param2_input"
                    ></el-input>
                    <el-input
                      :placeholder="`${$t(
                        'cuttingDock.NCExportSettings.params'
                      )}3`"
                      style="width: 100px"
                      maxlength="20"
                      show-word-limit
                      v-model="emergencyItem.param3"
                      id="engraving_setting_exportSetting_param3_input"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div>
                <a-button
                  id="a_button_rhl1lbp556"
                  @click="handleAddFunction"
                  :disabled="formData.emergencySetting.length >= 20"
                >
                  添加功能
                </a-button>
                <a-button
                  id="a_button_2tz9px8k6q"
                  @click="handleDeleteFunction"
                  :disabled="formData.emergencySetting.length < 2"
                  class="ml20"
                  >删除功能</a-button
                >
              </div>
            </div>
          </div>
          <div class="plank-code" id="plank-code">
            <div id="div_i5zgwbi1wd" class="head-title">
              {{ $t('cuttingDock.NCExportSettings.holeSetting') }}
            </div>
            <div class="common-box">
              <!-- <span class="small-title mr10"
                >{{ $t('cuttingDock.NCExportSettings.holeFileCategorize') }}
              </span>
              <a-checkbox
                id="engraving_setting_exportSetting_output56FDrillSortByCode_input"
                v-model="formData.drillFileSetting.output56FDrillSortByCode"
              ></a-checkbox>
              <span class="color-a">（{{ $t('cuttingDock.NCExportSettings.holeTip') }}）</span> -->
              <!-- 原“打孔文件按不同订单文件分文件夹单独放置”功能已迁移到“更多设置”页面中！” -->
              <goToMoreSettings
                :function-name="
                  translateLang(
                    'cuttingDock.NCExportSettings.fileManagerFunction'
                  )
                "
                :module-name="translateLang('main.head.fileManager')"
                router-path="/fileManage"
                :query-setting-id="$route.query.setting_id"
              >
              </goToMoreSettings>
            </div>
          </div>

          <div class="plank-code" id="singleFileSetting">
            <div id="div_abi71ow8q5" class="head-title">
              {{ $translateLang('单独文件加工设置') }}
              <a-switch
                style="margin-top: -4px"
                class="ml20"
                v-model="formData.singleFileSetting.enable"
              />
            </div>
            <!-- 智科用户(userInfo.platform == 22)展示第一版的内容,有增值包权限(secondaryProPer，智科也可以购买增值包)展示所有内容 -->
            <div
              class="common-box custom-single-file-setting"
              v-show="formData.singleFileSetting.enable"
            >
              <span class="small-title"
                >{{ $translateLang('选择单独输出工艺') }}
              </span>
              <a-select
                mode="multiple"
                class="single-file-process-select"
                dropdownClassName="single-file-process-dropdown"
                style="width: 605px; margin-top: 10px"
                :value="visibleProcessTypes"
                @change="handleVisibleProcessTypesChange"
                @dropdownVisibleChange="markExpiredPaidProcessTags"
                @dragover="handleDragOver"
              >
                <a-select-option
                  v-for="item in visibleSingleFileSettingOptions"
                  :key="`${item.value}`"
                  :value="item.value"
                  :title="$translateLang(item.label)"
                  :class="{
                    'expired-paid-process-option': isExpiredPaidProcess(
                      item.value
                    ),
                  }"
                >
                  <g-paid-feature
                    v-if="shouldShowProcessCrown(item.value)"
                    :permission-keys="secondaryProcessingPermissionKeys"
                    :iconStyle="{
                      top: '-6px',
                      right: '-15px',
                      fontSize: '16px',
                    }"
                  >
                    {{ $translateLang(item.label) }}
                  </g-paid-feature>
                  <span v-else>{{ $translateLang(item.label) }}</span>
                </a-select-option>
              </a-select>
              <span
                class="small-title mt20"
                v-show="
                  formData.singleFileSetting.processTypes.includes('hole') ||
                  formData.singleFileSetting.processTypes.includes('slot')
                "
                >{{ $translateLang('设置单独输出常规孔槽尺寸') }}
              </span>
              <div class="flex mt10">
                <div
                  v-show="
                    formData.singleFileSetting.processTypes.includes('hole')
                  "
                  class="hole-range-setting"
                >
                  <span class="small-title"
                    >{{ $translateLang('孔生效范围') }}
                    <span
                      class="add-btn ml5"
                      :class="{
                        'disabled-btn':
                          formData.singleFileSetting.holeRange.length >= 5,
                      }"
                      @click="handleAddHoleRange"
                      >{{ $translateLang('添加') }}</span
                    ></span
                  >
                  <div
                    class="mt10"
                    v-for="(holeItem, index) in formData.singleFileSetting
                      .holeRange"
                    :key="index"
                  >
                    <span class="mr10">{{ $translateLang('孔直径') }}</span>
                    <a-select
                      style="width: 100px; margin-right: 10px"
                      v-model="holeItem.operator"
                    >
                      <a-select-option
                        v-for="item in operationOptions"
                        :key="`hole_${item.value}`"
                        :value="item.value"
                        :title="$translateLang(item.label)"
                        >{{ $translateLang(item.label) }}</a-select-option
                      >
                    </a-select>
                    <a-input
                      style="width: 120px"
                      suffix="mm"
                      v-model="holeItem.value"
                      @input="
                        verifyInput({
                          value: holeItem.value,
                          formData: holeItem,
                          keys: ['value'],
                          rule: '5-2',
                          isThickFlag: true,
                        })
                      "
                      @dragover="handleDragOver"
                    />
                    <span
                      class="delete-btn"
                      @click="handleDeleteHoleRange(index)"
                      >{{ $translateLang('删除') }}</span
                    >
                  </div>
                </div>
                <div
                  class="slot-setting"
                  v-show="
                    formData.singleFileSetting.processTypes.includes('slot')
                  "
                >
                  <span class="small-title"
                    >{{ $translateLang('槽生效范围') }}
                    <span
                      class="add-btn ml5"
                      :class="{
                        'disabled-btn':
                          formData.singleFileSetting.slotRange.length >= 5,
                      }"
                      @click="handleAddSlotRange"
                      >{{ $translateLang('添加') }}</span
                    ></span
                  >
                  <div
                    class="mt10"
                    v-for="(slotItem, index) in formData.singleFileSetting
                      .slotRange"
                    :key="index"
                  >
                    <span class="mr10">{{ $translateLang('槽长边') }}</span>
                    <a-select
                      style="width: 100px; margin-right: 10px"
                      v-model="slotItem.slot_length.operator"
                    >
                      <a-select-option
                        v-for="item in operationOptions"
                        :key="`slot_length_${item.value}`"
                        :value="item.value"
                        :title="$translateLang(item.label)"
                        >{{ $translateLang(item.label) }}</a-select-option
                      >
                    </a-select>
                    <a-input
                      style="width: 120px"
                      suffix="mm"
                      v-model="slotItem.slot_length.value"
                      @input="
                        verifyInput({
                          value: slotItem.slot_length.value,
                          formData: slotItem,
                          keys: ['slot_length', 'value'],
                          rule: '5-2',
                          isThickFlag: true,
                        })
                      "
                      @dragover="handleDragOver"
                    />
                    <span class="slot-short-edge"
                      >{{ $translateLang('且')
                      }}{{ $translateLang('槽短边') }}</span
                    >
                    <a-select
                      style="width: 100px; margin-right: 10px"
                      v-model="slotItem.slot_width.operator"
                    >
                      <a-select-option
                        v-for="item in operationOptions"
                        :key="`slot_width_${item.value}`"
                        :value="item.value"
                        :title="$translateLang(item.label)"
                        >{{ $translateLang(item.label) }}</a-select-option
                      >
                    </a-select>
                    <a-input
                      style="width: 120px"
                      suffix="mm"
                      v-model="slotItem.slot_width.value"
                      @input="
                        verifyInput({
                          value: slotItem.slot_width.value,
                          formData: slotItem,
                          keys: ['slot_width', 'value'],
                          rule: '5-2',
                          isThickFlag: true,
                        })
                      "
                      @dragover="handleDragOver"
                    />
                    <span
                      class="delete-btn"
                      @click="handleDeleteSlotRange(index)"
                      >{{ $translateLang('删除') }}</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="custom-file-name"
                v-show="formData.singleFileSetting.processTypes.length"
              >
                <div style="min-width: 350px">
                  <div
                    class="custom-file-name-item"
                    v-if="
                      formData.singleFileSetting.processTypes.includes(
                        'arcStraightSlot'
                      )
                    "
                  >
                    <span>{{ $translateLang('圆弧折弯部分直槽') }}</span>
                    <a-input
                      style="width: 200px"
                      v-model="
                        formData.singleFileSetting.customFilename
                          .arcStraightSlot.template_string
                      "
                      @blur="
                        blurSelect(
                          $event,
                          formData.singleFileSetting.customFilename
                            .arcStraightSlot,
                          singleFileTag.plank_info,
                          'arcStraightSlot'
                        )
                      "
                      @input="
                        handleSingleFileTemplateInput(
                          $event,
                          formData.singleFileSetting.customFilename
                            .arcStraightSlot,
                          singleFileTag.plank_info,
                          'arcStraightSlot'
                        )
                      "
                      @dragover="handleSingleFileDragOver"
                      @drop="
                        dragSingleFileTagOver(
                          $event,
                          formData.singleFileSetting.customFilename
                            .arcStraightSlot,
                          singleFileTag.plank_info,
                          'arcStraightSlot'
                        )
                      "
                      :title="
                        formData.singleFileSetting.customFilename
                          .arcStraightSlot.template_string
                      "
                    />
                  </div>
                  <div
                    class="custom-file-name-item"
                    v-if="
                      formData.singleFileSetting.processTypes.includes(
                        'handleSlope'
                      )
                    "
                  >
                    <span>{{ $translateLang('斜边海棠角和斜边拉手') }}</span>
                    <a-input
                      style="width: 200px"
                      v-model="
                        formData.singleFileSetting.customFilename.handleSlope
                          .template_string
                      "
                      @blur="
                        blurSelect(
                          $event,
                          formData.singleFileSetting.customFilename.handleSlope,
                          singleFileTag.plank_info,
                          'handleSlope'
                        )
                      "
                      @input="
                        handleSingleFileTemplateInput(
                          $event,
                          formData.singleFileSetting.customFilename.handleSlope,
                          singleFileTag.plank_info,
                          'handleSlope'
                        )
                      "
                      @dragover="handleSingleFileDragOver"
                      @drop="
                        dragSingleFileTagOver(
                          $event,
                          formData.singleFileSetting.customFilename.handleSlope,
                          singleFileTag.plank_info,
                          'handleSlope'
                        )
                      "
                      :title="
                        formData.singleFileSetting.customFilename.handleSlope
                          .template_string
                      "
                    />
                  </div>
                  <div
                    class="custom-file-name-item"
                    v-if="
                      formData.singleFileSetting.processTypes.includes(
                        'curveHole'
                      )
                    "
                  >
                    <span>{{ $translateLang('内部异形') }}</span>
                    <a-input
                      style="width: 200px"
                      v-model="
                        formData.singleFileSetting.customFilename.curveHole
                          .template_string
                      "
                      @blur="
                        blurSelect(
                          $event,
                          formData.singleFileSetting.customFilename.curveHole,
                          singleFileTag.plank_info,
                          'curveHole'
                        )
                      "
                      @input="
                        handleSingleFileTemplateInput(
                          $event,
                          formData.singleFileSetting.customFilename.curveHole,
                          singleFileTag.plank_info,
                          'curveHole'
                        )
                      "
                      @dragover="handleSingleFileDragOver"
                      @drop="
                        dragSingleFileTagOver(
                          $event,
                          formData.singleFileSetting.customFilename.curveHole,
                          singleFileTag.plank_info,
                          'curveHole'
                        )
                      "
                      :title="
                        formData.singleFileSetting.customFilename.curveHole
                          .template_string
                      "
                    />
                  </div>
                  <div
                    class="custom-file-name-item"
                    v-if="
                      formData.singleFileSetting.processTypes.includes('hole')
                    "
                  >
                    <span>{{ $translateLang('常规孔') }}</span>
                    <a-input
                      style="width: 200px"
                      v-model="
                        formData.singleFileSetting.customFilename.hole
                          .template_string
                      "
                      @blur="
                        blurSelect(
                          $event,
                          formData.singleFileSetting.customFilename.curveHole,
                          singleFileTag.plank_info,
                          'curveHole'
                        )
                      "
                      @input="
                        handleSingleFileTemplateInput(
                          $event,
                          formData.singleFileSetting.customFilename.curveHole,
                          singleFileTag.plank_info,
                          'curveHole'
                        )
                      "
                      @dragover="handleSingleFileDragOver"
                      @drop="
                        dragSingleFileTagOver(
                          $event,
                          formData.singleFileSetting.customFilename.hole,
                          singleFileTag.plank_info,
                          'hole'
                        )
                      "
                      :title="
                        formData.singleFileSetting.customFilename.hole
                          .template_string
                      "
                    />
                  </div>
                  <div
                    class="custom-file-name-item"
                    v-if="
                      formData.singleFileSetting.processTypes.includes('slot')
                    "
                  >
                    <span>{{ $translateLang('常规槽') }}</span>
                    <a-input
                      style="width: 200px"
                      v-model="
                        formData.singleFileSetting.customFilename.slot
                          .template_string
                      "
                      @blur="
                        blurSelect(
                          $event,
                          formData.singleFileSetting.customFilename.slot,
                          singleFileTag.plank_info,
                          'slot'
                        )
                      "
                      @input="
                        handleSingleFileTemplateInput(
                          $event,
                          formData.singleFileSetting.customFilename.slot,
                          singleFileTag.plank_info,
                          'slot'
                        )
                      "
                      @dragover="handleSingleFileDragOver"
                      @drop="
                        dragSingleFileTagOver(
                          $event,
                          formData.singleFileSetting.customFilename.slot,
                          singleFileTag.plank_info,
                          'slot'
                        )
                      "
                      :title="
                        formData.singleFileSetting.customFilename.slot
                          .template_string
                      "
                    />
                  </div>
                </div>
                <div class="tag-pool">
                  <DataTagPool
                    :tagList="singleFileTag.plank_info"
                    :disabledTagNames="curveHoleDisabledTags"
                    :dropData.sync="dropData"
                    @selectChange="selectChange"
                    @dragStart="handleDargStart"
                  ></DataTagPool>
                </div>
              </div>
              <div class="merge-file-setting">
                <span class="small-title">{{
                  $translateLang('二次加工文件合并')
                }}</span>
                <a-switch
                  class="mh10"
                  v-model="formData.singleFileSetting.mergeFile"
                />
                <span class="color-a">{{
                  $translateLang(
                    '开启当导出的板件存在多个二次加工工艺，则会合并到同一个加工文件'
                  )
                }}</span>
                <div
                  class="merge-file-name"
                  v-if="formData.singleFileSetting.mergeFile"
                >
                  <div class="merge-file-name-item">
                    <span class="mr10 mt5">{{
                      $translateLang('合并文件名')
                    }}</span>
                    <a-input
                      style="width: 200px"
                      v-model="
                        formData.singleFileSetting.mergeFileName.template_string
                      "
                      @blur="
                        blurSelect(
                          $event,
                          formData.singleFileSetting.mergeFileName,
                          singleFileTag.plank_info,
                          'mergeFileName'
                        )
                      "
                      @input="
                        handleSingleFileTemplateInput(
                          $event,
                          formData.singleFileSetting.mergeFileName,
                          singleFileTag.plank_info,
                          'mergeFileName'
                        )
                      "
                      @dragover="handleSingleFileDragOver"
                      @drop="
                        dragSingleFileTagOver(
                          $event,
                          formData.singleFileSetting.mergeFileName,
                          singleFileTag.plank_info,
                          'mergeFileName'
                        )
                      "
                      :title="
                        formData.singleFileSetting.mergeFileName.template_string
                      "
                    />
                  </div>
                  <div class="tag-pool">
                    <DataTagPool
                      :tagList="singleFileTag.plank_info"
                      :disabledTagNames="mergeFileDisabledTags"
                      :dropData.sync="dropData"
                      @selectChange="selectChange"
                      @dragStart="handleDargStart"
                    ></DataTagPool>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchUserPermission } from '@/apis/auth'
import AnchorNav from '@/components/anchorNav/index.vue'
import DataTagPool from '@/components/dataTagPool'
import GPaidFeature from '@/components/g-paid-feature.vue'
import goToMoreSettings from '@/components/goToMoreSettings.vue'
import { USER_PERMISSION_KEY } from '@/data/auth'
import { ncExportSettingNavs } from '@/util/anchorNavData.ts'
import { translate } from '@/util/commonFun'
import { genUniId, verifyInputNumber } from '@/util/commonFuncs'
import { webId } from '@/util/configure'
import { mapGetters, mapMutations, mapState } from 'vuex'

const SINGLE_FILE_REQUIRED_TAG = '板件条码'
const SINGLE_FILE_REQUIRED_TAG_STR = '{板件条码}'
const SINGLE_FILE_CUSTOM_FILENAME_KEYS = [
  'arcStraightSlot',
  'handleSlope',
  'curveHole',
  'hole',
  'slot',
]
// 无增值包时仍可用的免费工艺
const FREE_PROCESS_TYPES = ['arcStraightSlot', 'handleSlope']
// 智科无增值包时额外可用
const ZHIKE_EXTRA_FREE_PROCESS_TYPES = ['curveHole']

export default {
  props: {
    obj: {
      type: [Array, Object],
      default: () => {},
    },
    isShowSecondaryCatalog: {
      type: Boolean,
      default: false,
    },
  },
  components: { DataTagPool, AnchorNav, goToMoreSettings, GPaidFeature },
  data() {
    return {
      isContainsSpecialChars: false,
      isShowEmergencySetting: false,
      tagList: [],
      navs: ncExportSettingNavs,
      formData: {
        // 开料机文件中注释
        fileAnnotation: {
          beforePlank: false, // 板件开始前加入工位代码
          beforePlankAddInfo: false, // 板件开始前加入当前板件信息
          beforeStartKnife: false, // 换刀前加入工位代码
          //大板信息自定义
          beforePlankAddCustomizeInfo: {
            label_ids: null,
            template_string: '',
          },
        },
        // 开料机文件合并
        fileMerge: {
          bEnd1: false, // 正反面合并 反面结束代码
          fBegin1: false, // 正反面合并 正面开始代码
          displayfbInfo: false, //文件名显示正反面信息
          bBegin2: false, // 单工位合并 反面开始代码
          fBegin2: false, // 单工位合并 正面开始代码
          bEnd2: false, // 单工位合并 反面结束代码
          fEnd2: false, // 单工位合并 正面结束代码
          bBegin3: false, // 双工位合并 反面开始代码
          bEnd3: false, // 双工位合并 反面结束代码
          fBegin3: false, // 双工位合并 正面开始代码
          fEnd3: false, // 双工位合并 正面结束代码
          doubleEdgeCombine: false, // 正反面合并
          doubleStationCombine: false, // 双工位合并
          singleStationCombine: false, // 单工位合并
        },
        // 开料机文件中类型
        fileNameSetting: {
          customizeSetting: {
            headerIds: {},
            templateString: '',
          }, // 自定义文件名(格式)
          // front: '',
          // back: '',
          front_info: '',
          back_info: '',
          stockNumLength: '',
          hasDelimiter: '',
          doubleStationSortName: false, // 按双工位自动排序
          is_generate_process_sort_number: true,
          labelMachineName: '', // 标签机开头
          machineCenterName: '', // 加工中心开头
          trim_direction_list: ['上', '下', '左', '右'], // 四边修边输入框
          // 大板长度标识范围
          big_plank_length_marking_range: [
            {
              min_length: '',
              max_length: '',
              marking: '',
            },
          ],
          custom_high_gloss_reverse: '翻高光面',
        },
        //
        fileType: {
          alwaysZ: false, // Z坐标补充
          exportFormat: 'default', // 星辉设备专用文件
          exportUsingBanlu: false, // 是否选中星辉设备专用文件
          fileNameType: 'NC', // 导出文件类型
          fileExtensionName: '.nc', // 导出文件类型
          semicolon: false, // 班鲁每行NC末尾加分号
          exportFormatAnnotation: '', // 是否选中E2-9星辉注释
          always_back_nc: '', //反面不加工时仍然生成含有反面结束代码的反面NC文件
        },
        // 开料机文件夹
        folderCategory: {},
        processingInstructionSetting: {
          GCommandShorthand: false, // g指令
          z_to_w_normal: false,
          z_to_w_gang_drill: false,
        },
        //文件格式设置
        fileFormatSetting: {
          platform: 'windows',
          fileEncoding: 'utf-8',
          fileSuffix: '',
        },
        // 板件条码设置
        barCodeSetting: {
          uniqueBarCode: false,
          uniqueBarCodeForPack: false,
          genSimpleLabelBarcode: false,
        },
        // 代码位置设置
        codePositionSetting: {
          stationEndCodeBeforeEndCodeB: false,
        },
        // 应急设置
        emergencySetting: [
          {
            settingKey: '', //应急码
            param1: '', //参数1
            param2: '', //参数2
            param3: '', //参数3
          },
        ],
        // 打孔文件设置
        drillFileSetting: {
          output56FDrillSortByCode: false,
        },
        // 单独文件设置
        singleFileSetting: {
          enable: true,
          handleSlopee: true,
          straight_arc_slot: false,
          processTypes: [],
          holeRange: [{ operator: '==', value: '', [webId]: genUniId() }],
          slotRange: [
            {
              slot_length: { operator: '==', value: '' },
              slot_width: { operator: '==', value: '' },
              [webId]: genUniId(),
            },
          ],
          customFilename: {
            arcStraightSlot: { label_ids: {}, template_string: '' },
            handleSlope: { label_ids: {}, template_string: '' },
            curveHole: { label_ids: {}, template_string: '' },
            hole: { label_ids: {}, template_string: '' },
            slot: { label_ids: {}, template_string: '' },
          },
          mergeFile: false,
          mergeFileName: { label_ids: {}, template_string: '' },
        },
      },
      isMergeFile: false, // 记录是否选中开料机文件合并
      singleStation: [], //记录选择的单工位合并
      doubleStation: [], // 记录选择的双工位合并
      frontBackStation: [], // 记录选择的正反面合并
      mergeRadio: '', // 记录开料机文件合并的单选
      xinghuiE2_9: false, // 记录是否选中星辉E2-9
      fileNameFormat: '',
      exampleFileName: '', // 自定义文件名示例
      dragItem: '', // 记录当前拖拽的标签
      checkObj: {
        doubleMerge: ['bEnd1', 'fBegin1', 'displayfbInfo'],
        singleStation: ['bBegin2', 'bEnd2', 'fBegin2', 'fEnd2'],
        doubleStation: ['bBegin3', 'bEnd3', 'fBegin3', 'fEnd3'],
      },
      nameArr: [],
      showError: false,
      errorStr: this.$t('cuttingDock.NCExportSettings.specialCodeErr'),
      dropData: {},
      // 自定义标签
      customTag: {
        plank_info: [],
      },
      // 选中DOM
      recodeSelect: null,
      edgeArr: [
        { label: 'front', value: 'front' },
        { label: 'back', value: 'back' },
        { label: 'left', value: 'left' },
        { label: 'right', value: 'right' },
      ],
      singleFileSettingOptions: [
        {
          label: '圆弧折弯部分直槽',
          value: 'arcStraightSlot',
        },
        {
          label: '斜边海棠角和斜边拉手',
          value: 'handleSlope',
        },
        { label: '内部异形', value: 'curveHole' },
        { label: '常规孔', value: 'hole' },
        { label: '常规槽', value: 'slot' },
      ],
      operationOptions: [
        { label: '等于', value: '==' },
        { label: '小于', value: '<' },
        { label: '大于', value: '>' },
        { label: '小于等于', value: '<=' },
        { label: '大于等于', value: '>=' },
      ],
      singleFileTag: {
        plank_info: [],
      },
      singleFileTemplatePrevMap: {
        curveHole: '',
        mergeFileName: '',
      },
      // 实时二次加工增值包权限（过期以接口为准；未拉取前用 store）
      secondaryProcessingEnable: undefined,
    }
  },
  watch: {
    'formData.fileType.fileExtensionName': {
      handler(newVal) {
        const specialChars = /[\\/:*?"<>|]/
        this.isContainsSpecialChars = specialChars.test(newVal)
        if (this.isContainsSpecialChars) {
          this.$refs.fileNameType.$el.style.borderColor = 'red'
        } else {
          this.$refs.fileNameType.$el.style.borderColor = '#3bbdd4'
        }
      },
      deep: true,
    },
    obj() {
      if (Object.keys(this.obj).length > 0) {
        this.formData = this.obj
        if (this.formData.fileMerge.doubleEdgeCombine == true) {
          this.mergeRadio = 'doubleMerge'
        } else if (this.formData.fileMerge.doubleStationCombine == true) {
          this.mergeRadio = 'doubleStation'
        } else if (this.formData.fileMerge.singleStationCombine == true) {
          this.mergeRadio = 'singleStation'
        } else {
          this.mergeRadio = ''
        }
        if (this.isNullFileSide) {
          this.formData.fileNameSetting.front_info = '正面'
          this.formData.fileNameSetting.back_info = '反面'
        }
        this.singleStation = []
        this.frontBackStation = []
        this.doubleStation = []
        this.checkObj.doubleMerge.forEach((v) => {
          if (this.formData.fileMerge[v] == true) {
            this.frontBackStation.push(v)
          }
        })
        this.checkObj.singleStation.forEach((v) => {
          if (this.formData.fileMerge[v] == true) {
            this.singleStation.push(v)
          }
        })
        this.checkObj.doubleStation.forEach((v) => {
          if (this.formData.fileMerge[v] == true) {
            this.doubleStation.push(v)
          }
        })

        if (this.formData.fileType.exportFormatAnnotation == 'xinghui') {
          this.xinghuiE2_9 = true
        }

        if (
          this.formData.fileMerge.doubleEdgeCombine ||
          this.formData.fileMerge.singleStationCombine ||
          this.formData.fileMerge.doubleStationCombine
        ) {
          this.isMergeFile = true
        }

        if (!this.formData.fileNameSetting.hasOwnProperty('hasDelimiter')) {
          this.formData.fileNameSetting.hasDelimiter = '/'
        }

        let pattern = /[^a-zA-Z0-9_@%\+\-\u4e00-\u9fa5]+$/g
        // 修改自定义的标签机开头, 去除特殊字符
        let labelStr = this.formData.fileNameSetting.labelMachineName
        if (labelStr != '') {
          if (pattern.test(labelStr)) {
            this.formData.fileNameSetting.labelMachineName = labelStr.replace(
              pattern,
              ''
            )
          }
        }
        // 修改自定义的加工中心开头, 去除特殊字符
        let machineStr = this.formData.fileNameSetting.machineCenterName
        if (machineStr != '') {
          if (pattern.test(machineStr)) {
            this.formData.fileNameSetting.machineCenterName =
              machineStr.replace(pattern, '')
          }
        }
        // 修改自定义的正面, 去除特殊字符
        let frontStr = this.formData.fileNameSetting.front_info
        if (frontStr != '') {
          if (pattern.test(frontStr)) {
            this.formData.fileNameSetting.front_info = frontStr.replace(
              pattern,
              ''
            )
          }
        }
        // 修改自定义的反面, 去除特殊字符
        let backStr = this.formData.fileNameSetting.back_info
        if (backStr != '') {
          if (pattern.test(backStr)) {
            this.formData.fileNameSetting.back_info = backStr.replace(
              pattern,
              ''
            )
          }
        }

        let tempName =
          this.formData.fileNameSetting.customizeSetting.templateString
        if (tempName != '') {
          let nameArr =
            this.formData.fileNameSetting.customizeSetting.templateString.match(
              /\{(.+?)\}/g
            )
          for (let i = 0; i < nameArr.length; i++) {
            nameArr[i] = nameArr[i].replace(/\{|\}/g, '')
          }
          this.nameArr = nameArr
          this.fileNameFormat = tempName
        }
        // 给 big_plank_length_marking_range 数组中的每个项添加 webId（如果没有的话）
        if (
          this.formData.fileNameSetting.big_plank_length_marking_range &&
          Array.isArray(
            this.formData.fileNameSetting.big_plank_length_marking_range
          )
        ) {
          this.formData.fileNameSetting.big_plank_length_marking_range.forEach(
            (item) => {
              if (!item[webId]) {
                item[webId] = genUniId()
              }
            }
          )
        }
        // 给孔/槽生效范围添加 webId（如果没有的话）
        ;(this.formData.singleFileSetting?.holeRange || []).forEach((item) => {
          if (!item[webId]) {
            item[webId] = genUniId()
          }
        })
        ;(this.formData.singleFileSetting?.slotRange || []).forEach((item) => {
          if (!item[webId]) {
            item[webId] = genUniId()
          }
        })
        this.autoFileName()
        this.initSingleFileTemplateProtection()
        this.handleProcessType()
        this.fetchSecondaryProcessingPermission()
      }
    },
    'formData.barCodeSetting': {
      handler(val) {
        if (val.uniqueBarCode) {
          val.uniqueBarCodeForPack = false
        } else if (val.uniqueBarCodeForPack) {
          val.uniqueBarCode = false
        }
      },
    },
    // nameArr(){
    //   this.dealNameArr()
    // }
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters('equipEnvironment', ['showConfig']),
    container() {
      return this.$refs.wrap
    },
    isNullFileSide() {
      const fileNameSetting = this.formData.fileNameSetting
      return !fileNameSetting.front_info && !fileNameSetting.back_info
    },
    curveHoleDisabledTags() {
      if (!this.shouldDisableSingleFileBarcodeTag()) {
        return []
      }
      return [SINGLE_FILE_REQUIRED_TAG]
    },
    mergeFileDisabledTags() {
      const str =
        this.formData.singleFileSetting?.mergeFileName?.template_string
      return this.hasRequiredBarcodeTag(str) ? [SINGLE_FILE_REQUIRED_TAG] : []
    },
    // 二次加工增值包权限（优先接口实时结果，判断是否过期）
    secondaryProPer() {
      if (typeof this.secondaryProcessingEnable === 'boolean') {
        return this.secondaryProcessingEnable
      }
      return !!this.$store.state.userPermissions?.secondary_processing
    },
    secondaryProcessingPermissionKeys() {
      return [USER_PERMISSION_KEY.SECONDARY_PROCESSING]
    },
    // 智科用户
    isZhikeUser() {
      return this.userInfo?.platform == 22
    },
    // 当前身份下的免费工艺
    freeProcessTypeValues() {
      if (this.isZhikeUser) {
        return [...FREE_PROCESS_TYPES, ...ZHIKE_EXTRA_FREE_PROCESS_TYPES]
      }
      return [...FREE_PROCESS_TYPES]
    },
    // 下拉选项：有权限展示全部；过期时展示免费项 + 已选中的收费项（便于置灰后删除）
    visibleSingleFileSettingOptions() {
      if (this.secondaryProPer) {
        return this.singleFileSettingOptions
      }
      const freeSet = new Set(this.freeProcessTypeValues)
      const selected = this.formData.singleFileSetting?.processTypes || []
      return this.singleFileSettingOptions.filter((option) => {
        if (freeSet.has(option.value)) return true
        return selected.includes(option.value)
      })
    },
    // 回显全部已选工艺（过期收费项也要展示，不能直接过滤掉）
    visibleProcessTypes() {
      return this.formData.singleFileSetting?.processTypes || []
    },
  },
  methods: {
    ...mapMutations(['setNcLabel']),
    handleChangeRollOverTag(val) {
      if (val) {
        this.nameArr.push('高光面翻面放板')
      } else {
        this.nameArr = this.nameArr.filter((item) => item !== '高光面翻面放板')
      }
      this.dealNameArr()
      this.autoFileName()
    },
    // 是否选中星辉E2-9注释
    changeXinghuiAnnotation() {
      this.formData.fileType.exportFormatAnnotation = this.xinghuiE2_9
        ? 'xinghui'
        : ''
    },
    // 切换文件名格式时, 判断E2-9格式
    changeExportFormat() {
      if (this.formData.fileType.exportFormat == 'default') {
        this.xinghuiE2_9 = false
        this.formData.fileType.exportFormatAnnotation = ''
      }
    },
    // 选中开料机文件合并
    fileMergeChange() {
      if (!this.isMergeFile) {
        this.mergeRadio = ''
        this.formData.fileMerge.doubleEdgeCombine = false
        this.formData.fileMerge.singleStationCombine = false
        this.formData.fileMerge.doubleStationCombine = false
      }
    },
    // 选中开料机文件合并单选
    changeFileMerge() {
      this.formData.fileMerge.doubleEdgeCombine = false
      this.formData.fileMerge.singleStationCombine = false
      this.formData.fileMerge.doubleStationCombine = false
      switch (this.mergeRadio) {
        case 'doubleMerge':
          this.formData.fileMerge.doubleEdgeCombine = true
          break
        case 'singleStation':
          this.formData.fileMerge.singleStationCombine = true
          break
        case 'doubleStation':
          this.formData.fileMerge.doubleStationCombine = true
          break
      }
    },
    // 更改正反面合并
    changeDoubleMerge() {
      this.checkObj.doubleMerge.forEach((v) => {
        this.formData.fileMerge[v] = false
      })
      this.frontBackStation.forEach((v) => {
        this.formData.fileMerge[v] = true
      })
    },
    // 更改单工位合并
    changeSingleStation() {
      this.checkObj.singleStation.forEach((v) => {
        this.formData.fileMerge[v] = false
      })
      this.singleStation.forEach((v) => {
        this.formData.fileMerge[v] = true
      })
    },
    // 更改双工位合并
    changeDoubleStation() {
      this.checkObj.doubleStation.forEach((v) => {
        this.formData.fileMerge[v] = false
      })
      this.doubleStation.forEach((v) => {
        this.formData.fileMerge[v] = true
      })
    },
    // 复制标签
    copyTag(index) {
      var clipboard = new this.$copy(`.tag-item${index}`)
      clipboard.on('success', (e) => {
        this.$message({
          type: 'success',
          message: this.$t('cuttingDock.NCExportSettings.copySuccess'),
          offset: 70,
          duration: 1000,
        })
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        this.$message({
          type: 'success',
          message: this.$t('cuttingDock.NCExportSettings.copyErr'),
          offset: 70,
          duration: 1000,
        })
        clipboard.destroy()
      })
    },
    // 拖拽标签
    startDrag(event, item) {
      this.dragItem = item
    },
    // 放入时触发函数, 深度拷贝拖动的标签dom, 将克隆之后的标签放入盒子, 不影响之前的dom
    dropOver(event) {
      if (this.dragItem) {
        event.target.focus()
        this.fileNameFormat += `{${this.dragItem.label_name_show}}`
        this.autoFileName()
        this.$nextTick(() => {
          event.preventDefault()
          this.nameArr.push(this.dragItem.label_name_show)
        })
      }
    },
    //
    removeItem(index) {
      let s = this.fileNameFormat.match(/\{(.+?)\}/g)
      s.splice(index, 1)
      this.fileNameFormat = s.join('')
      this.nameArr.splice(index, 1)
      this.autoFileName()
    },
    // 拖动放入时, 阻止事件冒泡
    handleDragOver(event, index) {
      event.preventDefault()
    },
    dragTagOver(e, obj, list, cacheKey) {
      e.preventDefault()
      const tagName = this.dropData?.label_name_show
      if (
        tagName === SINGLE_FILE_REQUIRED_TAG &&
        this.hasRequiredBarcodeTag(obj.template_string)
      ) {
        return
      }
      obj['template_string'] += `{${tagName}}`
      this.tagPoolTextareaChange(obj, list)
      if (cacheKey) {
        this.singleFileTemplatePrevMap[cacheKey] = obj.template_string
      }
      this.recodeSelect = null
    },
    handleSingleFileDragOver(e) {
      e.preventDefault()
      const input = e.target
      if (input.tagName !== 'INPUT') return
      input.focus()
      const pos = this.getInputCaretPositionFromMouse(input, e.clientX)
      input.setSelectionRange(pos, pos)
    },
    dragSingleFileTagOver(e, obj, list, cacheKey) {
      e.preventDefault()
      const input = e.target
      const tagName = this.dropData?.label_name_show
      if (!tagName) return
      if (
        tagName === SINGLE_FILE_REQUIRED_TAG &&
        this.hasRequiredBarcodeTag(obj.template_string)
      ) {
        return
      }
      const tagStr = `{${tagName}}`
      const start = input.selectionStart ?? obj.template_string?.length ?? 0
      const end = input.selectionEnd ?? start
      const s = obj.template_string ?? ''
      obj.template_string = `${s.substring(0, start)}${tagStr}${s.substring(
        end
      )}`
      this.tagPoolTextareaChange(obj, list)
      if (cacheKey) {
        this.singleFileTemplatePrevMap[cacheKey] = obj.template_string
      }
      this.recodeSelect = null
      this.$nextTick(() => {
        const newPos = start + tagStr.length
        input.setSelectionRange(newPos, newPos)
        input.focus()
      })
    },
    getInputCaretPositionFromMouse(input, clientX) {
      const text = input.value ?? ''
      const rect = input.getBoundingClientRect()
      const style = window.getComputedStyle(input)
      const paddingLeft = parseFloat(style.paddingLeft) || 0
      const relativeX = clientX - rect.left - paddingLeft + input.scrollLeft

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      ctx.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`

      let position = text.length
      for (let i = 0; i <= text.length; i++) {
        const width = ctx.measureText(text.substring(0, i)).width
        if (width >= relativeX) {
          position = i
          break
        }
      }
      return position
    },
    // 标签数据改变生成新的label_ids
    tagPoolTextareaChange(obj, list) {
      obj['label_ids'] = this.tempStringToObj(
        obj['template_string'],
        list[0].arr
      )
    },
    // 根据字符串和list返回新的label_ids
    tempStringToObj(str, list) {
      if (!str) return {}
      const strReg = str.match(/(?<={).*?(?=})/g) ?? []
      const obj = {}
      strReg.forEach((item) => {
        // eslint-disable-next-line no-prototype-builtins
        if (!obj.hasOwnProperty(item)) {
          const find = list.find((d) => d.label_name_show == item)
          if (find) {
            obj[item] = find.id
          }
        }
      })
      return obj
    },
    // 重新给选中文本赋值
    selectChange(str) {
      if (this.recodeSelect) {
        const { obj, start, end, list, cacheKey } = this.recodeSelect
        const tagName = str.replace(/^\{|\}$/g, '')
        if (
          tagName === SINGLE_FILE_REQUIRED_TAG &&
          this.hasRequiredBarcodeTag(obj.template_string)
        ) {
          this.recodeSelect = null
          return
        }
        const s = obj['template_string']
        obj['template_string'] = `${s.substring(0, start)}${str}${s.substring(
          end
        )}`
        this.tagPoolTextareaChange(obj, list)
        if (cacheKey) {
          this.singleFileTemplatePrevMap[cacheKey] = obj.template_string
        }
      }
      this.recodeSelect = null
    },
    handleDargStart() {
      this.dragItem = ''
    },
    /** 是否为权限过期后仍留在配置中的收费工艺 */
    isExpiredPaidProcess(type) {
      if (this.secondaryProPer) return false
      return !this.freeProcessTypeValues.includes(type)
    },
    /** 基础免费工艺不展示皇冠；智科账号内部异形也不展示 */
    shouldShowProcessCrown(type) {
      if (FREE_PROCESS_TYPES.includes(type)) return false
      if (this.isZhikeUser && type === 'curveHole') return false
      return true
    },
    getExpiredPaidProcessTypes() {
      const processTypes = this.formData.singleFileSetting?.processTypes || []
      return processTypes.filter((type) => this.isExpiredPaidProcess(type))
    },
    /** 给已选收费工艺标签加置灰样式（可删除） */
    markExpiredPaidProcessTags() {
      this.$nextTick(() => {
        const root = this.$el?.querySelector?.('.single-file-process-select')
        if (!root) return
        const paidTitles = this.singleFileSettingOptions
          .filter((item) => this.isExpiredPaidProcess(item.value))
          .map((item) => this.$translateLang(item.label))
        root.querySelectorAll('.ant-select-selection__choice').forEach((el) => {
          const title = el.getAttribute('title') || ''
          if (paidTitles.includes(title)) {
            el.classList.add('expired-paid-process-tag')
          } else {
            el.classList.remove('expired-paid-process-tag')
          }
        })
      })
    },
    async fetchSecondaryProcessingPermission() {
      try {
        const res = await fetchUserPermission({
          permission_type: 'SECONDARY_PROCESSING',
        })
        if (res.status === 1) {
          this.secondaryProcessingEnable = !!res.data?.enable
          this.markExpiredPaidProcessTags()
        }
      } catch (err) {
        if (err?.message === 'canceled') return
      }
    },
    /**
     * 保存前校验：权限过期时若仍存在收费工艺则拦截
     * @returns {Promise<boolean>}
     */
    async validateExpiredPaidProcessTypes() {
      // 未开启单独文件加工设置时不校验
      if (!this.formData.singleFileSetting?.enable) return true
      await this.fetchSecondaryProcessingPermission()
      const paidTypes = this.getExpiredPaidProcessTypes()
      if (!paidTypes.length) return true
      this.$message.warning(
        this.$translateLang('存在付费二次加工工艺，请删除后重新保存')
      )
      return false
    },
    handleProcessType() {
      // 过期时保留已选收费工艺（置灰可删），不再自动清掉
      if (!this.formData.singleFileSetting) return
      if (!Array.isArray(this.formData.singleFileSetting.processTypes)) {
        this.$set(this.formData.singleFileSetting, 'processTypes', [])
      }
      this.markExpiredPaidProcessTags()
    },
    handleVisibleProcessTypesChange(values) {
      const nextValues = values || []
      if (!this.secondaryProPer) {
        const prev = this.formData.singleFileSetting.processTypes || []
        const freeSet = new Set(this.freeProcessTypeValues)
        const added = nextValues.filter((type) => !prev.includes(type))
        const illegalAdded = added.filter((type) => !freeSet.has(type))
        if (illegalAdded.length) {
          this.$message.warning(
            this.$translateLang('付费二次加工工艺权限已过期，无法新增')
          )
          this.formData.singleFileSetting.processTypes = nextValues.filter(
            (type) => !illegalAdded.includes(type)
          )
          this.markExpiredPaidProcessTags()
          return
        }
      }
      this.formData.singleFileSetting.processTypes = nextValues
      this.markExpiredPaidProcessTags()
    },
    handleAddHoleRange() {
      if (this.formData.singleFileSetting.holeRange.length >= 5) {
        this.$message.warning(this.$translateLang('最多添加5条'))
        return
      }
      this.formData.singleFileSetting.holeRange.push({
        operator: '==',
        value: '',
        [webId]: genUniId(),
      })
    },
    handleDeleteHoleRange(index) {
      this.formData.singleFileSetting.holeRange.splice(index, 1)
    },
    handleAddSlotRange() {
      if (this.formData.singleFileSetting.slotRange.length >= 5) {
        this.$message.warning(this.$translateLang('最多添加5条'))
        return
      }
      this.formData.singleFileSetting.slotRange.push({
        slot_length: { operator: '==', value: '' },
        slot_width: { operator: '==', value: '' },
        [webId]: genUniId(),
      })
    },
    handleDeleteSlotRange(index) {
      this.formData.singleFileSetting.slotRange.splice(index, 1)
    },
    // 编辑框失焦保存选中文本
    blurSelect(e, obj, list, cacheKey) {
      if (e.target.selectionStart || e.target.selectionEnd) {
        this.recodeSelect = {
          start: e.target.selectionStart,
          end: e.target.selectionEnd,
          obj,
          list,
          cacheKey,
        }
      }
    },
    hasRequiredBarcodeTag(str) {
      return str?.includes(SINGLE_FILE_REQUIRED_TAG_STR)
    },
    /** 已勾选的二次加工工艺输入框是否均已包含板件条码 */
    shouldDisableSingleFileBarcodeTag() {
      const processTypes = this.formData.singleFileSetting?.processTypes ?? []
      const customFilename = this.formData.singleFileSetting?.customFilename
      if (!processTypes.length || !customFilename) {
        return false
      }
      const activeKeys = SINGLE_FILE_CUSTOM_FILENAME_KEYS.filter((key) =>
        processTypes.includes(key)
      )
      if (!activeKeys.length) {
        return false
      }
      return activeKeys.every((key) =>
        this.hasRequiredBarcodeTag(customFilename[key]?.template_string)
      )
    },
    handleSingleFileTemplateInput(e, obj, list, cacheKey) {
      const newVal = e.target.value
      const prevVal = this.singleFileTemplatePrevMap[cacheKey]

      if (
        prevVal &&
        this.hasRequiredBarcodeTag(prevVal) &&
        !this.hasRequiredBarcodeTag(newVal)
      ) {
        obj.template_string = prevVal
        e.target.value = prevVal
        this.$message.warning(this.$translateLang('板件条码不可删除'))
        return
      }

      this.singleFileTemplatePrevMap[cacheKey] = newVal
      this.tagPoolTextareaChange(obj, list)
    },
    initSingleFileTemplateProtection() {
      const singleFileSetting = this.formData.singleFileSetting
      if (!singleFileSetting) return

      const curveHole = singleFileSetting.customFilename?.curveHole
      if (curveHole) {
        if (!curveHole.template_string) {
          curveHole.template_string = SINGLE_FILE_REQUIRED_TAG_STR
        }
        this.singleFileTemplatePrevMap.curveHole = curveHole.template_string
        if (this.singleFileTag.plank_info?.[0]?.arr?.length) {
          this.tagPoolTextareaChange(curveHole, this.singleFileTag.plank_info)
        }
      }

      const mergeFileName = singleFileSetting.mergeFileName
      if (mergeFileName) {
        if (!mergeFileName.template_string) {
          mergeFileName.template_string = SINGLE_FILE_REQUIRED_TAG_STR
        }
        this.singleFileTemplatePrevMap.mergeFileName =
          mergeFileName.template_string
        if (this.singleFileTag.plank_info?.[0]?.arr?.length) {
          this.tagPoolTextareaChange(
            mergeFileName,
            this.singleFileTag.plank_info
          )
        }
      }
    },
    // 修改分隔符
    modifyDelimiter() {
      let reg = /[^-_]/
      this.formData.fileNameSetting.hasDelimiter =
        this.formData.fileNameSetting.hasDelimiter.replace(
          new RegExp(reg, 'g'),
          ''
        )
      this.autoFileName()
    },
    // 自动生成文件名示例
    autoFileName() {
      let list = []
      this.tagList.forEach((v) => {
        list = [...list, ...v.arr]
      })
      let tempName = this.fileNameFormat
      // 筛选出标签池里所拥有的数据
      let s = this.fileNameFormat.match(/\{(.+?)\}/g)
      if (s != null) {
        let tempTags = s.map((item) => item.replace(/\{|\}/g, ''))
        let testArr = []
        tempTags.forEach((v) => {
          list.forEach((x) => {
            if (x.label_name_show === v) {
              let setting = this.formData.fileNameSetting
              switch (x.label_name) {
                case 'stockNum':
                  let num = Number(setting.stockNumLength)
                  if (num > 0) {
                    let str = '0'.repeat(num - 1) + '1'
                    testArr.push(str)
                  } else {
                    testArr.push(x.val)
                  }
                  break
                case 'labelMachineName':
                  if (setting.labelMachineName != '') {
                    testArr.push(setting.labelMachineName)
                  } else {
                    testArr.push(x.val)
                  }
                  break
                case 'machineCenterName':
                  if (setting.machineCenterName != '') {
                    testArr.push(setting.machineCenterName)
                  } else {
                    testArr.push(x.val)
                  }
                  break
                case 'direction':
                  if (setting.front_info == '' && setting.back_info == '') {
                    // testArr.push(x.val)
                    testArr.push('/')
                  } else {
                    let str = ''
                    if (setting.front_info != '') {
                      str = `${setting.front_info}/`
                    } else {
                      str = '/'
                    }
                    if (setting.back_info != '') {
                      str += setting.back_info
                    } else {
                      str += ''
                    }
                    testArr.push(str)
                  }
                  break
                case 'trim_edge':
                  if (
                    !setting.trim_direction_list.length ||
                    setting.trim_direction_list.every((item) => item == '')
                  ) {
                    testArr.push('6')
                  } else {
                    testArr.push(
                      `6/${setting.trim_direction_list[0]}6${setting.trim_direction_list[1]}6${setting.trim_direction_list[2]}6${setting.trim_direction_list[3]}6`
                    )
                  }
                  break
                case 'high_gloss_side_reverse':
                  testArr.push(
                    this.formData.fileNameSetting.custom_high_gloss_reverse
                  )
                  break
                default:
                  testArr.push(x.val)
                  break
              }
            }
          })
        })
        if (this.formData.fileNameSetting.hasDelimiter) {
          this.exampleFileName = testArr.join(
            this.formData.fileNameSetting.hasDelimiter
          )
        } else {
          this.exampleFileName = testArr.join('')
        }
      } else {
        this.exampleFileName = this.fileNameFormat
      }
    },
    inputCheck() {
      this.formData.fileNameSetting.stockNumLength =
        this.formData.fileNameSetting.stockNumLength.replace(/[^\d]/g, '') // 去除数字和小数点以外的数字
    },
    verifyInput(option) {
      verifyInputNumber(
        option.value,
        option.formData,
        option.keys,
        option.rule,
        option.isMinus,
        option.min,
        option.isEmpty,
        option.max,
        option.isThickFlag
      )
    },
    handleInputMark(index) {
      // 标识限制5个字符，不限制内容
      if (
        this.formData.fileNameSetting.big_plank_length_marking_range[index]
          .marking.length > 5
      ) {
        this.formData.fileNameSetting.big_plank_length_marking_range[
          index
        ].marking = this.formData.fileNameSetting.big_plank_length_marking_range[
          index
        ].marking.slice(0, 5)
      }
    },
    handleAddMarking() {
      if (
        this.formData.fileNameSetting.big_plank_length_marking_range.length < 10
      ) {
        this.formData.fileNameSetting.big_plank_length_marking_range.push({
          min_length: '',
          max_length: '',
          marking: '',
          [webId]: genUniId(),
        })
      } else {
        this.$message.warning(this.$translateLang('最多添加10个'))
      }
    },
    handleDeleteMarking(index) {
      if (
        this.formData.fileNameSetting.big_plank_length_marking_range.length <= 1
      ) {
        this.$message.warning(this.$translateLang('不能全部删除'))
        return
      }
      this.formData.fileNameSetting.big_plank_length_marking_range.splice(
        index,
        1
      )
    },
    wordLimit(word, num, index) {
      let pattern = /[^a-zA-Z0-9_@%\+\-\u4e00-\u9fa5]+$/
      if (['front_info', 'back_info'].includes(word)) {
        pattern = /[^a-zA-Z0-9_@%\+\-\.\u4e00-\u9fa5]+$/
      }
      let str =
        word !== 'trim_direction_list'
          ? this.formData.fileNameSetting[word]
          : this.formData.fileNameSetting[word][index]
      if (pattern.test(str)) {
        this.$nextTick(() => {
          this.errorStr = this.$t('cuttingDock.NCExportSettings.specialCodeErr')
          this.$refs[`error${num}`].className = 'error-info error-info-in'
          if (word === 'trim_direction_list') {
            this.$set(this.edgeArr[num - 5], 'errorInfoIn', true)
          }
        })
      } else {
        // this.showError = false
        this.$nextTick(() => {
          this.$refs[`error${num}`].className = 'error-info'
          if (word === 'trim_direction_list') {
            this.$set(this.edgeArr[num - 5], 'errorInfoIn', false)
          }
        })
      }
      if (str.length == 16) {
        this.$nextTick(() => {
          if (word == 'trim_direction_list') {
            this.formData.fileNameSetting[word][index] = str.slice(0, -1)
          } else {
            this.formData.fileNameSetting[word] = str.slice(0, -1)
          }
          this.errorStr = this.$t('cuttingDock.NCExportSettings.lengthLimit')
          this.$refs[`error${num}`].className = 'error-info error-info-in'
          if (word === 'trim_direction_list') {
            this.$set(this.edgeArr[num - 5], 'errorInfoIn', true)
          }
        })
      } else if (str.length < 16) {
        this.$refs[`error${num}`].className = 'error-info'
        if (word === 'trim_direction_list') {
          this.$set(this.edgeArr[num - 5], 'errorInfoIn', false)
        }
      }
      if (word == 'trim_direction_list') {
        this.formData.fileNameSetting[word][index] =
          this.formData.fileNameSetting[word][index].replace(pattern, '')
      } else {
        this.formData.fileNameSetting[word] = this.formData.fileNameSetting[
          word
        ].replace(pattern, '')
      }
      this.autoFileName()
    },
    // 获取nc自定义文件名的接口
    getNcCustomLabel() {
      this.$getByToken(
        '/get_electronic_saw_label',
        {
          label_class: 'ncLabel',
        },
        (res) => {
          let ncLabel = res.data
          let arr = []
          Object.keys(ncLabel).forEach((v) => {
            arr = [...arr, ...ncLabel[v]]
          })
          arr.forEach((v) => {
            switch (v.label_name) {
              case 'stockNum':
                v.val = '001'
                break
              case 'matCode':
                v.val = '多层实木'
                break
              case 'thick':
                v.val = '18'
                break
              case 'texture':
                v.val = 'T01'
                break
              case 'direction':
                v.val = '正面/反面'
                break
              case 'labelMachineName':
                v.val = '标签机开头'
                break
              case 'machineCenterName':
                v.val = '加工中心开头'
                break
              case 'plankWidth':
                v.val = '1220'
                break
              case 'plankHeight':
                v.val = '2440'
                break
              case 'address':
                v.val = '板件旋转_侧孔错误'
                break
              case 'orderNo':
                v.val = '220818-154'
                break
              case 'surplus_size':
                v.val = '1440（1000）-1000（600）/1440-600'
                break
              case 'trim_edge':
                v.val = '6/上6下6左6右6'
                break
              case 'big_plank_length_mark':
                v.val = '长度标识'
                break
              case 'is_surplus':
                v.val = '余'
                break
              default:
                v.val = ''
            }
          })
          this.setNcLabel(arr)
          let plankInfo = arr.filter((v) => v.label_type == 'plank_info')
          let otherInfo = arr.filter((v) => v.label_type == 'other_info')
          let orderInfo = arr.filter((v) => v.label_type == 'order_info')
          const plank_info = arr.filter((v) => v.label_type == 'big_plank_info')
          this.customTag.plank_info = [{ arr: plank_info }]
          this.tagList = [
            {
              title: 'materialPage.orderInfo',
              arr: orderInfo,
            },
            {
              title: 'cuttingDock.NCExportSettings.plankInfo',
              arr: plankInfo,
            },
            {
              title: 'cuttingDock.NCExportSettings.otherInfo',
              arr: otherInfo,
            },
          ]
        }
      )
    },
    getSingleFileLabel() {
      this.$getByToken(
        '/get_electronic_saw_label',
        {
          label_class: 'singleFile',
        },
        (res) => {
          let singleFileLabel = res.data
          let arr = []
          Object.keys(singleFileLabel).forEach((v) => {
            arr = [...arr, ...singleFileLabel[v]]
          })
          this.singleFileTag.plank_info = [{ arr: arr }]
          this.initSingleFileTemplateProtection()
        }
      )
    },
    //组织锚点改变url
    handlePrevent(e, link) {
      e.preventDefault()
    },
    // 处理nc自定义文件名
    dealNameArr() {
      let list = []
      this.tagList.forEach((v) => {
        list = [...list, ...v.arr]
      })
      let arr = JSON.parse(JSON.stringify(this.nameArr))
      let tempStr = arr.map((v) => `{${v}}`)
      if (this.formData.fileNameSetting.hasDelimiter) {
        this.formData.fileNameSetting.customizeSetting.templateString =
          tempStr.join(this.formData.fileNameSetting.hasDelimiter)
      } else {
        this.formData.fileNameSetting.customizeSetting.templateString =
          tempStr.join('')
      }
      let headerIds = {}
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < arr.length; j++) {
          if (list[i].label_name_show === arr[j]) {
            headerIds[list[i].label_name_show] = list[i].id
          }
        }
      }
      this.formData.fileNameSetting.customizeSetting.headerIds = headerIds
    },
    translateLang(key) {
      return translate(key)
    },
    // 应急码添加功能
    handleAddFunction() {
      this.formData.emergencySetting.push({
        settingKey: '', //应急码
        param1: '', //参数1
        param2: '', //参数2
        param3: '', //参数3
      })
    },
    // 应急码删除功能
    handleDeleteFunction() {
      // 删除最后一条应急码设置
      const dIndex = this.formData.emergencySetting.length - 1
      this.formData.emergencySetting?.splice(dIndex, 1)
    },
  },
  mounted() {
    this.fetchSecondaryProcessingPermission()
    this.getNcCustomLabel()
    this.getSingleFileLabel()
    document
      .getElementById('ncExportSetting_fileNameType_input')
      .addEventListener('dragover', (event) => {
        event.preventDefault()
      })
  },
}
</script>

<style lang="less" scoped>
@import '~@/style/engraving.less';
.export-setting {
  background: #fff;
  span {
    cursor: default;
  }
  .wrap {
    .navRightWrapWidth();
    .main-setting {
      .auto-sort {
        box-sizing: border-box;
        padding: 24px;
      }
      .custom-head {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 24px 24px 24px;
        .custom-label-head {
          display: flex;
          align-items: center;
          margin-right: 32px;
          .ant-input {
            width: 290px;
          }
        }
        .custom-cure-head {
          display: flex;
          align-items: center;
          .ant-input {
            width: 290px;
          }
        }
        .plank-num-length {
          .ant-input {
            width: 90px;
          }
        }
        .length-identifier-item {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .ant-input-affix-wrapper {
            width: 120px;
          }
          .ant-input {
            width: 120px;
          }
          .add-btn {
            margin-right: 10px;
            margin-left: 20px;
            color: #18a8c7;
            cursor: pointer;
          }
          .delete-btn {
            color: #f5222d;
            cursor: pointer;
          }
        }
        .has-error-info {
          position: relative;
          .error-info {
            position: absolute;
            display: block;
            width: 100%;
            color: red;
            font-size: 12px;
            transform: scaleY(0);
            transform-origin: top;
            top: unset !important;
            left: unset !important;
            transition: all 0.1s ease-out;
          }
          .error-info-in {
            transform: scaleY(1);
          }
        }
      }
      .custom-head.plank-mark {
        align-items: flex-start;
      }
      .tag-lake {
        box-sizing: border-box;
        padding: 0 24px;
        .tag-box {
          box-sizing: border-box;
          overflow: hidden;
          border: 1px solid #e9e9e9;
          border-radius: 4px;
          .custom-form-head {
            box-sizing: border-box;
            height: 44px;
            padding: 11px 24px;
            background: #e9e9e9;
            span:first-child {
              color: #000;
              font-weight: 600;
              font-size: 16px;
            }
            span:last-child {
              color: #8c8c8c;
              font-size: 14px;
            }
          }
          .custom-form-main {
            box-sizing: border-box;
            padding: 0 24px;
            &:last-child .tag-item {
              border-bottom: none;
            }
            .tag-item {
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding: 29px 0 21px 0;
              border-bottom: 1px solid #e9e9e9;
              & > span {
                display: inline-block;
                width: 128px;
                font-size: 16px;
                text-align: right;
                user-select: none;
              }
              .tags {
                display: flex;
                align-items: center;
                & > span {
                  display: inline-block;
                  min-width: 102px;
                  height: 32px;
                  margin-right: 8px;
                  color: #5a5a5a;
                  font-size: 14px;
                  line-height: 32px;
                  text-align: center;
                  background: #eaf4f6;
                  cursor: pointer;
                }
              }
            }
          }
        }
        .custom-file-name {
          margin-top: 24px;
          & > div {
            margin-bottom: 16px;
          }
          .file-has-delimiter {
            .ant-input {
              width: 100px;
            }
          }
          .file-name-format {
            display: flex;
            align-items: center;
            .file-format-box {
              display: flex;
              min-width: 290px;
              min-height: 42px;
              // height: 34px;
              padding-right: 24px;
              line-height: 32px;
              border: 1px solid #d9d9d9;
              border-radius: 4px;
              padding-top: 4px;
              padding-bottom: 4px;
              padding-left: 11px;
              .default-show {
                padding-left: 8px;
              }
              .tag {
                display: inline-block;
                min-width: 102px;
                height: 32px;
                margin-right: 8px;
                color: #5a5a5a;
                font-size: 14px;
                line-height: 32px;
                text-align: center;
                background: #eaf4f6;
                & > i {
                  margin-left: 8px;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
      .merge-box {
        .merge-box-title {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          width: 100%;
          padding: 24px;
          border-bottom: 1px solid #e9e9e9;
          span {
            margin-right: 16px;
            color: #000;
            font-weight: 600;
            font-size: 18px;
          }
        }
        .radio-check-box {
          box-sizing: border-box;
          padding: 12px 24px;
          .radio-check-item {
            margin: 12px 0;
          }
        }
      }
      .annotation {
        .annotation-box {
          display: flex;
          flex-wrap: wrap;
          float: left;
          box-sizing: border-box;
          width: 40%;
          padding: 24px;
          & > div {
            width: 100%;
            // margin-right: 80px;
            margin-bottom: 24px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .plank-info {
            display: flex;
            .ant-input {
              width: 350px;
              height: 110px;
              resize: none;
            }
          }
        }
        .tag-pool {
          float: left;
          width: 50%;
        }
      }
      .annotation.annotation-disable {
        span {
          color: #d9d9d9 !important;
        }
      }

      .format {
        .format-box {
          box-sizing: border-box;
          padding: 24px;
          .format-check-box {
            display: flex;
            margin-bottom: 24px;
            & > div {
              margin-right: 80px;
            }
          }
          .xinghui {
            margin-bottom: 24px;
            .ant-checkbox {
              margin: 0 24px 0 8px;
            }
            .xinghui-zhushi {
              .ant-checkbox {
                margin: 0;
              }
              .ant-checkbox + span {
                padding-right: 0;
              }
            }
          }
          .format-radio-box {
            display: flex;
            margin-bottom: 24px;
          }
        }
      }
      .format.format-disable {
        span {
          color: #d9d9d9 !important;
        }
      }
      .g-order {
        .common-box {
          box-sizing: border-box;
          padding: 24px;
        }
      }
      .file-format-setting-box {
        box-sizing: border-box;
        padding: 24px;
        .common-box {
          & > span {
            margin-right: 24px;
          }
          margin-bottom: 24px;
        }
      }
      .plank-code {
        .common-box {
          box-sizing: border-box;
          padding: 24px;
        }
        .common-box.custom-single-file-setting {
          display: flex;
          flex-direction: column;
          .single-file-process-select {
            ::v-deep .expired-paid-process-tag {
              color: rgba(0, 0, 0, 0.25) !important;
              background: #f5f5f5 !important;
              border-color: #d9d9d9 !important;
            }
            ::v-deep .expired-paid-process-option {
              color: rgba(0, 0, 0, 0.25);
            }
          }
        }
        .add-btn {
          cursor: pointer;
          color: #3bbdd4;
        }
        .delete-btn {
          cursor: pointer;
          color: #ff0000;
          margin-left: 10px;
        }
        .disabled-btn {
          color: #d9d9d9;
          cursor: not-allowed;
        }
        .hole-range-setting {
          margin-right: 130px;
        }
        .slot-setting {
          .slot-short-edge {
            margin-left: 10px;
            margin-right: 10px;
          }
        }
        .custom-file-name {
          margin-top: 50px;
          display: flex;
          &-item {
            margin-bottom: 16px;
            & > span {
              margin-right: 10px;
            }
          }
          .tag-pool {
            width: 50%;
            margin-left: 80px;
          }
        }
        .merge-file-setting {
          margin-top: 50px;
        }
        .merge-file-name {
          display: flex;
          margin-top: 50px;
          &-item {
            display: flex;
          }
          .tag-pool {
            width: 50%;
            margin-left: 150px;
          }
        }
      }
    }
  }
}
.err-tip {
  top: 40px;
  left: 140px;
  color: red;
}
.custom-head-err-boder {
  border-color: #ff0000;
  // box-shadow: none !important;
  &:focus {
    box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.16) !important;
  }
}
.error-info {
  display: block;
  width: 100%;
  color: red;
  font-size: 12px;
  transform: scaleY(0);
  transform-origin: top;
  transition: all 0.1s ease-out;
}
.err-text-tip {
  position: unset !important;
}
.error-info-in {
  transform: scaleY(1);
}
</style>
<style lang="less">
.single-file-process-dropdown {
  .ant-select-dropdown-menu-item {
    .g-paid-feature {
      padding-right: 12px;
    }

    // 选中态字重变粗会连带放大 iconfont，统一锁定皇冠尺寸
    .g-paid-feature__icon,
    .icon-huangguan-VIP {
      font-size: 16px !important;
      font-weight: 400 !important;
      line-height: 1 !important;
      transform: none !important;
    }
  }
}
</style>
